import ServiceHighlights from "reusables/sections/ServiceHighlights";

const items = [
  {
    icon: "local_hospital",
    title: "Infection Control Standards",
    description:
      "We follow strict hygiene and infection control protocols appropriate for clinical environments, reducing the risk of cross-contamination.",
  },
  {
    icon: "elderly",
    title: "Care Homes & Residential Facilities",
    description:
      "We provide sensitive, thorough cleaning for care homes and residential facilities, maintaining high standards of hygiene for vulnerable residents.",
  },
  {
    icon: "sanitizer",
    title: "Clinical & High-Touch Surface Disinfection",
    description:
      "We pay particular attention to high-touch surfaces, waiting areas, and clinical rooms — using appropriate medical-grade disinfectants.",
  },
  {
    icon: "verified_user",
    title: "Trained & Vetted Staff",
    description:
      "All staff are fully vetted and trained to operate in sensitive healthcare environments with the required level of professionalism and discretion.",
  },
];

function Healthcare_Section1() {
  return (
    <ServiceHighlights
      title="Why Choose Our Healthcare & Medical Facility Cleaning?"
      items={items}
    />
  );
}

export default Healthcare_Section1;
